import { render, staticRenderFns } from "./BankStatementV2.vue?vue&type=template&id=ee42113a&"
import script from "./BankStatementV2.vue?vue&type=script&lang=ts&"
export * from "./BankStatementV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee42113a')) {
      api.createRecord('ee42113a', component.options)
    } else {
      api.reload('ee42113a', component.options)
    }
    module.hot.accept("./BankStatementV2.vue?vue&type=template&id=ee42113a&", function () {
      api.rerender('ee42113a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cash-management/reports/BankStatementV2.vue"
export default component.exports